import axios from '@/plugins/axios'

/**
 * Set favorite audiences
 */
const setFavoriteAudiences = async ({
  // eslint-disable-next-line camelcase
  audience_id,
  // eslint-disable-next-line camelcase
  company_id
}) => {
  try {
    const params = {
      audience_id: audience_id,
      company_id: company_id
    }

    const { data } = await axios.post('favorite-audiences', params)
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Destroy favorite audiences
 */
const destroyFavoriteAudiences = async (uuid) => {
  try {
    const response = await axios.delete(`favorite-audiences/${uuid}`)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get favorite audiences
 */
const getFavoriteAudiences = async () => {
  try {
    const response = await axios.get('favorite-audiences')
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get audiences
 */
const getAudiences = async ({
  // eslint-disable-next-line camelcase
  category_id,
  // eslint-disable-next-line camelcase
  advertiser_id,
  name,
  page,
  type = null
}) => {
  try {
    const params = {
      page: page
    }

    // eslint-disable-next-line camelcase
    if (category_id) params.category_id = category_id
    // eslint-disable-next-line camelcase
    if (advertiser_id) params.advertiser_id = advertiser_id

    if (name) params.name = name
    if (type) params.type = type

    const response = await axios.get('audiences', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  destroyFavoriteAudiences,
  getAudiences,
  getFavoriteAudiences,
  setFavoriteAudiences
}
